export default __webpack_public_path__ + "static/media/article3.a369aaef.jpg";